import { FC } from 'react';

const LabelIcon: FC = () => {
    return (
        <svg
            className="icon br-icon-label"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1123_1788)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.8901 21.975C15.5651 22.949 13.7141 22.875 12.4991 21.766C9.06203 18.6277 5.79346 15.3098 2.70709 11.826C2.32588 11.4027 2.06576 10.8846 1.95409 10.326C1.56009 8.29301 0.727091 3.22201 1.97609 1.97201C3.22609 0.722009 8.29609 1.55601 10.3281 1.95001C10.8881 2.06101 11.4061 2.32101 11.8301 2.70201C15.3138 5.78838 18.6318 9.05695 21.7701 12.494C22.8791 13.708 22.9501 15.561 21.9791 16.886C21.2781 17.841 20.5371 18.8 19.6691 19.666C18.8041 20.531 17.8461 21.273 16.8911 21.974L16.8901 21.975ZM9.45809 6.52301C9.65954 6.71335 9.82078 6.94215 9.93227 7.19588C10.0438 7.44961 10.1032 7.72313 10.1072 8.00025C10.1112 8.27737 10.0595 8.55246 9.95529 8.80928C9.85108 9.06609 9.69643 9.29939 9.50049 9.4954C9.30456 9.69141 9.0713 9.84613 8.81453 9.95043C8.55775 10.0547 8.28267 10.1065 8.00555 10.1026C7.72843 10.0988 7.4549 10.0394 7.20112 9.92796C6.94735 9.81656 6.7185 9.6554 6.52809 9.45401C6.15732 9.06186 5.9541 8.54058 5.96161 8.00095C5.96913 7.46133 6.18679 6.94591 6.56833 6.56423C6.94987 6.18256 7.46522 5.96473 8.00484 5.95703C8.54446 5.94933 9.06582 6.15237 9.45809 6.52301Z"
                    fill="black"
                    fill-opacity="0.12"
                    stroke="currentColor"
                    stroke-width="2"
                />
            </g>
            <defs>
                <clipPath id="clip0_1123_1788">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LabelIcon;
